import { render, staticRenderFns } from "./MessagePage.vue?vue&type=template&id=8c7ea10a&scoped=true&"
import script from "./MessagePage.vue?vue&type=script&lang=js&"
export * from "./MessagePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7ea10a",
  null
  
)

export default component.exports